module.exports = __webpack_public_path__ + "img/ds10.a0a11bca.png";